import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../../system/components/ProtectedRoute';
import { UserRoles } from '../../system/types';

// Créer des fichiers routes.tsx pour chaque sous-dossier
import PreparationParrainagePotentielRoutes from './PreparationParrainagePotentiel/routes';
import ImportParrainagesRoutes from './importParrainages/routes';

// Définition des permissions requises pour chaque module de vue
const modulePermissions: Record<string, UserRoles[]> = {
    PreparationParrainagePotentiel: ['ADMIN', 'USER'],
    ImportParrainages: ['ADMIN', 'USER'],
};

/**
 * Centralise les routes de la section "view"
 * Tous les modules s'enregistrent ici automatiquement
 */
const ActionRoutes: React.FC = () => {
    // Fonction pour wrapper les routes de chaque module avec ProtectedRoute
    const protectRoutes = (
        routes: React.ReactElement[],
        requiredRoles: UserRoles[]
    ) => {
        return routes.map((route, index) => {
            // Cloner la route existante avec ses props
            return (
                <Route
                    key={`protected-${index}`}
                    path={route.props.path}
                    element={
                        <ProtectedRoute requiredRoles={requiredRoles}>
                            {route.props.element}
                        </ProtectedRoute>
                    }
                />
            );
        });
    };

    // Combinaison des routes protégées
    const allModuleRoutes = [
        ...protectRoutes(
            PreparationParrainagePotentielRoutes,
            modulePermissions.PreparationParrainagePotentiel
        ),
        ...protectRoutes(
            ImportParrainagesRoutes,
            modulePermissions.ImportParrainages
        ),
    ];

    return <Routes>{allModuleRoutes}</Routes>;
};

export default ActionRoutes;
